<template>
    <div>
        <div name="tab-container1">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="特定服务商" name="specServicer"></el-tab-pane>
                <el-tab-pane label="合同服务商" name="contractServicer"></el-tab-pane>
            </el-tabs>
        </div>
        <div v-if="activeName == 'specServicer'" name="btn-bar" class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="setDefServicer">新增</button>
            </div>
        </div>
        <div class="column-layout">
            <div class="table-layout" v-if="activeName == 'specServicer'">
                <el-table ref="tableList" :data="servicerList" border style="width: 100%">
                    <el-table-column label="机构名称" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.retailerComName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务商名称" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.servicerName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务类型" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.servcTypeName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务" align="center" width="150">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.servcTitle}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同" align="center" width="150">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.contractNo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否默认" align="center">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block" v-if="rows.row.defaulted">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" v-if="!rows.row.defaulted " @click="doDefServicer(rows.row.id)">设置默认</a>
                            <a class="swb-btn-link" v-if="!rows.row.defaulted " @click="deleteDefServicer(rows.row.id)">移除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table ref="tableList" :data="contractServicerList" border style="width: 100%">
                    <el-table-column label="机构名称" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.shopName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务商名称" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.servicerName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务类型" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.servcTypeName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="服务" align="center" width="150">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.title}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同" align="center" width="180">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{rows.row.contractNo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="left">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click="saveContractServicer(rows.row)">加入特定</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, EventBus } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import specApi from '../../api/spec'

    export default {
        name: 'swb-spec-servicer-list-for-comn',
        desc: '常规项目服务商',
        props: {
            // 定义id
            requireId: {
                type: Number
            },
            repairId: {
                type: Number
            },
            retailerComId: {
                type: Number
            },
            // 服务类型
            servcTypeId: {
                type: Number
            },
            item: {
                type: Object
            }
        },
        data: function () {
            return {
                activeName: "specServicer",
                servicerList: [],
                contractServicerList: []
            }
        },
        created: function () {
            //
            let self = this;
            //
            self.getShopComnSpecServicerList();
            self.getShopComnContractServicerList();
        },
        methods: {
            getShopComnSpecServicerList: function () {
                let self = this;
                let postData = {};
                postData.requireId = this.requireId;
                postData.retailerComId = this.retailerComId;
                postData.servcTypeId = this.servcTypeId;
                specApi.getShopComnSpecServicerListByDevcId(postData, function (result) {
                    if(result.type == "info") {
                        //
                        self.servicerList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getShopComnContractServicerList: function () {
                let self = this;
                let postData = {};
                postData.comnRequireId = this.requireId;
                postData.servcTypeId = this.servcTypeId;
                postData.retailerComId = this.retailerComId;
                specApi.getShopComnContractServicerListByDevcId(postData, function (result) {
                    if(result.type == "info") {
                        //
                        self.contractServicerList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            setDefServicer: function() {
                let self = this;
                let comId = this.retailerComId;
                let item = this.item;
                Vue.$showDialog({
                    title: "服务商-设置",
                    width: 1500,
                    height: 800,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-shop-comn-spec-servicer-save :item="item" :comId="comId" ref="swb_shop_device_spec_servicer_save"></swb-shop-comn-spec-servicer-save>' +
                    '</div>',
                    data: {
                        item: item,
                        comId: comId
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_shop_device_spec_servicer_save.getDlgResult();
                        if(result.type == "info") {
                            let specServicerList = result.data;
                            let loading = MsgBox.loading();
                            specApi.saveShopComnSpecServicerList(specServicerList, function (result) {
                                loading.close();
                                if(result.type == "info") {
                                    MsgBox.success("保存成功");
                                    self.getShopComnSpecServicerList();
                                } else {
                                    MsgBox.warning(result.message);
                                    return false;
                                }
                            })
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    }
                });
            },
            deleteDefServicer: function (id) {
                let self = this;
                this.$confirm("确定删除该服务商？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    specApi.deleteShopComnSpecServicer(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("删除成功");
                            self.getShopComnSpecServicerList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }).catch(function () {
                });
            },
            doDefServicer: function (id) {
                let self = this;
                this.$confirm("确定设置该服务商？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    specApi.doDefaultShopComnSpecServicer(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("设置成功");
                            self.getShopComnSpecServicerList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }).catch(function () {
                });
            },
            saveContractServicer: function(item) {
                let self = this;
                let specServicerList = [];
                let specServicer = {};
                if(this.retailerComId == null) {
                    specServicer.repairId = -1;
                    specServicer.requireId = this.item.id;
                } else {
                    specServicer.repairId = this.item.id;
                    specServicer.requireId = this.item.requireId;
                    specServicer.retailerComId = this.item.comId;
                    specServicer.retailerBizUnitId = this.item.comId;
                }
                specServicer.requireTitle = this.item.title;
                specServicer.retailerId = this.item.retailerId;
                specServicer.retailerName = this.item.retailerName;
                //
                specServicer.servcTypeId = item.type;
                specServicer.ssuId = item.ssuId;
                specServicer.servcId = item.servcId;
                specServicer.servcTitle = item.title;
                specServicer.servicerId = item.servicerId;
                specServicer.servicerName = item.servicerName;
                specServicer.contractId= item.contractId;
                specServicer.contractNo= item.contractNo;
                specServicer.contractItemId= item.contractItemId;
                specServicerList.push(specServicer);
                //
                let loading = MsgBox.loading();
                specApi.saveShopComnSpecServicerList(specServicerList, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        MsgBox.success("保存成功");
                        self.getShopComnSpecServicerList();
                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/spec/ServicerListForComn.vue